/* eslint-disable */
import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import GlobalStateContext from '~/context/GlobalStateContext';
import { Link } from 'react-router-dom';
import CheckBox from '~/components/CheckBox';
import { Quote } from '~/components/Quote';
import Img from '~/components/Elements/Img';
import DataLayer from '~/components/DataLayer';
import V360 from '~/components/V360';
import configData from '~/config/data';
import V360Header from './V360Header';
import V360Info from './V360Info';
import V360Tutorial from './V360Tutorial/index';
import V360Loader from './V360Loader';
import V360Versions from './V360Versions';
import { PaperClip } from '~/components/PaperClip';
import css from './V360Page.scss';

const classes = {
	root: css.v360Page,
	header: css.v360PageHeader,
	headerWrapper: css.v360PageHeaderWrapper,
	headerTitle: css.v360PageHeaderTitle,
	headerImage: css.v360PageHeaderImage,
	content: css.v360PageContent,
	current: css.v360PageCurrent,
	currentInfo: css.v360PageCurrentInfo,
	cardLayout: css.v360PageCardLayout,
	currentChoice: css.v360PageCurrentChoice,
	currentView: css.v360PageCurrentView,
	currentView360: css.v360PageCurrentView360,
	currentViewTutorial: css.v360PageCurrentViewTutorial,
	currentViewLoader: css.v360PageCurrentViewLoader,
	versions: css.v360PageVersions,
	ctas: css.v360PageCtas,
	cta1: css.v360PageCta1,
	cta2: css.v360PageCta2,
 	button: css.v360PageButton,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	mobile: PropTypes.bool,
	name: PropTypes.string,
	version: PropTypes.string,
	data: PropTypes.object,
};

const defaultProps = {
	className: '',
	classes,
	mobile: true,
	name: '',
	version: '',
	data: configData.versions.data,
};

export const V360Page = React.forwardRef(({
	className,
	classes,
	mobile,
	name,
	version,
	data: info,
	...props
}, ref) => {
	const rootRef = React.useRef();
	const contentRef = React.useRef();
	const v360Ref = React.useRef();
	const loaderRef = React.useRef();
	const thumbsRef = React.useRef();
	const globalStateContext = React.useContext(GlobalStateContext);
	const [currentIndex, setCurrentIndex] = React.useState(0);
	const [currentType, setCurrentType] = React.useState(0);
	const [currentDevice] = React.useState(mobile ? 'mobile' : 'desktop');
	const [didUnderstood, setDidUnderstood] = React.useState(false);
	const [isStarted, setIsStarted] = React.useState(false);
	const [isTracked, setIsTracked] = React.useState(false);
	const [isLoading, setIsLoading] = React.useState(false);

	const onClickV360 = React.useCallback((evt) => {
		setIsStarted(true);
	}, [isStarted]);

	const onLoadStart = React.useCallback(() => {
		loaderRef.current.setProgress(0);
		setIsLoading(true);
	}, [isLoading]);

	const onLoadError = React.useCallback((file, xhr) => {
	}, []);

	const onLoadProgress = React.useCallback((file, percentage) => {
		loaderRef.current.setProgress(percentage);
	}, []);

	const onLoadComplete = React.useCallback((response) => {
		loaderRef.current.setProgress(0);
		setIsLoading(false);
	}, [isLoading]);

	const onRotate = React.useCallback((frame) => {
		setDidUnderstood(true);
		setIsTracked((wasTracked) => {
			if (!wasTracked) {
				const versionData = info.versions[currentIndex][currentType];
				const versionInfo = versionData[currentDevice];
				DataLayer.push('VersionsPage_GirouCarro', versionInfo.name, versionData.doubleCabin);
			}
			return true;
		});
	}, [currentIndex, isTracked]);

	const onClickChoice = React.useCallback((checked) => {
		DataLayer.push('VersionsPage_SelecionouCabine', checked ? 'dupla' : 'simples');
		setCurrentType(checked ? 1 : 0);
		setIsTracked(false);
		// setIsStarted(false);
	}, [currentType, isTracked, isStarted]);

	const onChangeVersion = React.useCallback((index) => {
		setCurrentIndex(index);
		setCurrentType(0);
		setIsTracked(false);
		// setIsStarted(false);
	}, [currentIndex, currentType, isTracked, isStarted]);


	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// RENDER
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

	React.useEffect(() => {
		if (thumbsRef.current) {
			thumbsRef.current.resize();
		}
	}, [globalStateContext.menuToggleProgress, mobile]);

	React.useImperativeHandle(ref, () => ({
		root: rootRef.current,
		v360: v360Ref.current,
	}));

	// console.log('V360Page', V360Page)
	// console.log('endurance', info.versions[currentIndex][currentType][currentDevice].name !== 'ENDURANCE')
	return (

		<section
			// {...props}
			id={V360Page.displayName}
			data-ui-anchor={V360Page.displayName}
			className={cls(classes.root, className)}
			ref={rootRef}>
			<div className={cls(classes.content)} ref={contentRef}>
				{/* PaperClip ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				<PaperClip
					className={cls(classes.paperClip)}
					stripes={'#ff7d32'}
					align={PaperClip.ALIGN_RIGHT}
				/>

				{/* Header ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				<V360Header
					className={classes.header}
					title={info.title}
					image={{ src: info.garantia }}
				/>

				{/* Current ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				<div className={cls(classes.current)}>
					<V360Info
						className={classes.currentInfo}
						fullname={info.versions[currentIndex][currentType][currentDevice].fullname}
						details={info.versions[currentIndex][currentType][currentDevice].details}
					/>
					<div className={cls(classes.currentView)}>
					{info.versions[currentIndex][currentType][currentDevice].name === 'ENDURANCE' ? 
					<div className={classes.cardLayout + " static_img"}>
						<img src={info.versions[currentIndex][currentType].doubleCabin ? "/assets/images/endurance-dc.png" : "/assets/images/endurance-cs.png"}></img>
					</div> :
						<V360
							ref={v360Ref}
							className={cls(classes.currentView360)}
							width={mobile ? 768 : 1920}
							height={mobile ? 433 : 1080}
							texturesPath={info.versions[currentIndex][currentType][currentDevice].dirname}
							texturesExtensionFiles={info.versions[currentIndex][currentType][currentDevice].ext}
							totalTextures={30}
							texturesToLoad={isStarted ? 30 : 1}
							shouldResetPositionOnChange={false}
							onTouchStart={onClickV360}
							onMouseDown={onClickV360}
							onLoadStart={onLoadStart}
							onLoadError={onLoadError}
							onLoadProgress={onLoadProgress}
							onLoadComplete={onLoadComplete}
							onRotate={onRotate}
						/>}
						<V360Tutorial
							className={classes.currentViewTutorial}
							display={isStarted && !didUnderstood}
						/>
						{info.versions[currentIndex][currentType][currentDevice].name !== 'ENDURANCE' && <V360Loader
							ref={loaderRef}
							className={classes.currentViewLoader}
							started={isStarted}
							display={isLoading}
							onClick={onClickV360}
						/>}
					</div>

					{/* Versions ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					<CheckBox
						className={classes.currentChoice}
						id={'cabine-dupla'}
						labelNo={'Cabina<br/>Plus'}
						labelYes={'Cabina<br/>Doble'}
						onClick={onClickChoice}
						checked={info.versions[currentIndex][currentType].doubleCabin}
						disabled={info.versions[currentIndex].length !== 2}
					/>

					{/* Versions ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					<div className={cls(classes.versions)}>
						<V360Versions
							ref={thumbsRef}
							list={info.versions}
							currentType={currentType}
							onChange={onChangeVersion}
							mobile={mobile}
						/>
					</div>
				</div>

				{/* CTAs ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				<div className={cls(classes.ctas)}>
					<div className={cls(classes.cta1)}>
						<Fade bottom>
							<DataLayer onEvent={'VersionsPage_ClicouCompreOSeu'} args={[]}>
								<a className={classes.button} href={'https://fiat.com.ar/contactenos?type=191'}>
									ELEGÍ LA TUYA
								</a>
							</DataLayer>
						</Fade>
					</div>
					<div className={cls(classes.cta2)}>
						<Fade bottom>
							<DataLayer onEvent={'VersionsPage_ClicouCompareVersoes'} args={[]}>
								<Link className={cls(classes.button)} dangerouslySetInnerHTML={{ __html: 'Compará versiones' }} to={{
									pathname: '/comparativo',
									state: { },
								}} />
							</DataLayer>
						</Fade>
					</div>
				</div>
			</div>
		</section>
	);
});

V360Page.displayName = 'V360Page';
V360Page.propTypes = propTypes;
V360Page.defaultProps = defaultProps;
export default V360Page;


